$(document).ready(function(){
  if ($('div').hasClass('shopify-policy__container')) {
    $('.shopify-policy__body div').prepend($('.shopify-policy__title h1'));
    $('.shopify-policy__body div h1:first-child').addClass('title');
    
    $('.shopify-policy__container').addClass('max-w-9xl mx-auto mt-6 md:flex-row md:flex-wrap md:justify-between px-6 lg:px-9 lg:mt-9');
    $('.shopify-policy__body').addClass('customized_textarea');
    
    $('.shopify-policy__title').remove();
    $('.shopify-policy__body div').removeClass('rte');
    $('div').removeClass('shopify-policy__container');
    $('div').removeClass('shopify-policy__body');
  }
})